module.exports = __webpack_public_path__ + "static/img/物流运输.4bbf5a15.jpeg";